/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // todo:測試
  test: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // todo:測試
    setTest: (state, action) => {
      state.test = action.payload;
    },
  },
});

// todo:測試
export const { setTest } = authSlice.actions;

export default authSlice.reducer;
